<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    width="800px"
    class="default-dialog"
  >
    <div class="title">自定义工资项目</div>
    <div v-for="(item,i) in list" :key="i">
        <div>{{item.name}}</div>
        <div class="children_box">
            <template v-if="item.children&&item.children.length">
                <div v-for="(child,childI) in item.children" :key="childI" class="child_item">
                    <el-input style="width:120px;border:0;" v-model.trim="child.name"></el-input>
                    <i class="el-icon-circle-close" @click="removeItem(child,i,childI)"></i>
                </div>
            </template>
            <div class="addI">
                    <i class="el-icon-plus" @click="addItem(i,item.type)"></i>
            </div>
        </div>
    </div>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {findSetProjectList,saveSetProject,delSetProject} from '@/api/index.js'
export default {
  data() {
    return {
      visible: false,
      list: [
        {
          name: "工资总额",
          type:1,
          children: [
           
          ],
        },
        {
          name: "应扣工资",
          type:2,
          children: [
           
          ],
        },
        {
          name: "实发工资调整", 
          type:3,
          children: [
            
          ],
        },
      ],
    };
  },
  methods: {
    querySetProjectList(){
        this.list.forEach(e=>{
          e.children = []
        })
        findSetProjectList().then(res=>{
          if(res.data.code==1){
            res.data.data.forEach(e=>{
              if(e.type==1){
                this.list[0].children.push(e)
              }
              if(e.type==2){
                this.list[1].children.push(e)
              }
              if(e.type==3){
                this.list[2].children.push(e)
              }
            })
          }
        })
    },
    addItem(i,type){
        this.list[i].children.push({
            name:'',
            type:type,
        })
    },
    removeItem(item,i,childI){
      if(item.id){
        delSetProject({id:item.id}).then(res=>{
          if(res.data.code==1){
            this.$message.success(res.data.msg)
            this.querySetProjectList()
          }
        })
      }else {
        this.list[i].children.splice(childI,1)
      }
   
    },
    openTask() {
      this.visible = true;
      this.querySetProjectList()
    },
    submit() {
      let list = this.list.flatMap((parent)=>parent.children)
      let item = list.find(e=>e.name=='')
      if(!item){
          list = list.filter((e,i)=>{
            e.sort=i
            return e
          })
          saveSetProject(list).then(res=>{
            if(res.data.code==1){
              this.$message.success(res.data.msg)
              this.querySetProjectList()
              this.visible = false
            }
          })
      }else {
        this.$message.error('项目名称不能为空')
      }
    },
  },
};
</script>

<style lang="less" scoped>
.addI {
    width: 14px;
    color: #268AFF;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid #268AFF;
    height: 14px;
    justify-content: center;
    padding: 2px;
    cursor: pointer;
    font-size: 12px;
}
.child_item {
    position: relative;
    width: 140px;
    height: 50px;
    display: flex;
    margin-right: 15px;
    align-items: center;
    background: transparent;
    /deep/ .el-input__inner {
        border: 0;
        border-radius: 0;
    }
    i {
        position: absolute;
        top: 0;
        cursor: pointer;
        right: 3px;
    }
}
.children_box {
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;
    background: rgba(246, 248, 250, 1);
    padding: 27px 20px;
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/AddObject.vue